import { ClientProviderProfile } from '../../api/ProfileClientView';
import { isClientProviderProfile } from '../../api/ProfileClientView/ProfileClientView';
import { PublicProvider } from '../../api/Providers';

/**
 * Returns true/false for each possible profile highlight
 *  determining if it should display or not
 *  */
export function getProfileKeyHighlights(profile: PublicProvider | ClientProviderProfile) {
  if (profile?.is_disabled) {
    return {
      licensed: false,
      oneThousandPlusBooked: false,
      styleSeatVerified: false,
    };
  }
  const blurb = profile.blurb ? profile.blurb.toLowerCase() : '';

  return {
    licensed: blurb.includes('license') || blurb.includes('certified') || blurb.includes('education'),
    oneThousandPlusBooked: isClientProviderProfile(profile)
      ? profile.has_at_least_1000_appointments
      : profile.total_booked_appointments_count >= 1000,
    styleSeatVerified: profile.can_process_payments,
  };
}
